import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as R from 'ramda';

import { formatNgbDate, parseDateInput, toNgbDate } from './utils';

const isNumber = R.is(Number);

@Injectable()
export class PcsNgbDateParserFormatter implements NgbDateParserFormatter {

  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = parseDateInput(value).trim().split('-');
      if (dateParts.length === 3 &&
        isNumber(Number(dateParts[0])) &&
        isNumber(Number(dateParts[1])) &&
        isNumber(Number(dateParts[2]))) {
        return toNgbDate(new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2])));
      }
    }
  }

  format(date: NgbDateStruct): string {
    return date && formatNgbDate(date);
  }

}
